// extracted by mini-css-extract-plugin
export default {"base":"styles_base__BjGbQ","rounded":"styles_rounded__rC4Xn","white":"styles_white__RXN9K","success":"styles_success__s4N53","danger":"styles_danger__y5wyR"};